// Subject normalization shared between the admin inbox UI and its tests.
// Strips stacked reply/forward prefixes (`Re:`, `Réponse:`, `Fwd:`, `Fw:`,
// `TR:`, `AW:`), collapses internal whitespace, and lowercases so trivial
// casing differences don't break grouping. Returns "" for missing/empty
// subjects so every (sans objet) message groups together.

const PREFIX_RE = /^(re|r[eé]p|fw|fwd|tr|tr.?\s*f|aw)\s*:\s*/i;

export function normalizeSubject(raw) {
  let s = (raw || "").trim();
  for (let i = 0; i < 5 && PREFIX_RE.test(s); i++) {
    s = s.replace(PREFIX_RE, "");
  }
  return s.replace(/\s+/g, " ").trim().toLowerCase();
}
